import { Tooltip, TooltipProps } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import * as Colors from 'src/theme/colors';
import * as Weights from 'src/theme/weights';

const useStyles = makeStyles()((theme) => ({
  tooltipContainer: {
    width: 400,
    padding: theme.spacing(1),
    '& > *': {
      color: Colors.GraySmall,
    },
  },
  tooltipContent: {
    color: Colors.NonHoverBorder,
    fontSize: '14px',
    fontWeight: Weights.regular,
    lineHeight: '21px',
  },
}));

interface InfoTooltipProps {
  label: string;
  children: React.ReactElement;
  disableHoverListener?: TooltipProps['disableHoverListener'];
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  label,
  children,
  disableHoverListener,
}) => {
  const { classes } = useStyles();
  return (
    <Tooltip
      title={label}
      disableHoverListener={disableHoverListener}
      classes={{
        popper: classes.tooltipContainer,
        tooltip: classes.tooltipContent,
      }}
    >
      {children}
    </Tooltip>
  );
};

export default InfoTooltip;
